import './utils';

window.addEventListener('scroll', (e) => {
	const sp = document.querySelectorAll('.simple-parallax');

	for (let i = 0; i < sp.length; i++) {
		let factor = 0.01;
		let direction = -1;
		let scroll = window.scrollY;

		if (sp[i].classList.contains('sp10') && isInView(sp[i])) {
			if (sp[i].classList.contains('down')) {
				direction = 1;
			}
			let position = scroll * factor * 10 * direction;
			sp[i].style.transform = 'translate3d(0px, ' + position + 'px, 0px)';
		}

		if (sp[i].classList.contains('sp20') && isInView(sp[i])) {
			if (sp[i].classList.contains('down')) {
				direction = 1;
			}
			let position = scroll * factor * 20 * direction;
			sp[i].style.transform = 'translate3d(0px, ' + position + 'px, 0px)';
		}

		if (sp[i].classList.contains('sp30') && isInView(sp[i])) {
			if (sp[i].classList.contains('down')) {
				direction = 1;
			}
			let position = scroll * factor * 30 * direction;
			sp[i].style.transform = 'translate3d(0px, ' + position + 'px, 0px)';
		}

		if (sp[i].classList.contains('sp40') && isInView(sp[i])) {
			if (sp[i].classList.contains('down')) {
				direction = 1;
			}
			let position = scroll * factor * 40 * direction;
			sp[i].style.transform = 'translate3d(0px, ' + position + 'px, 0px)';
		}

		if (sp[i].classList.contains('sp50') && isInView(sp[i])) {
			if (sp[i].classList.contains('down')) {
				direction = 1;
			}
			let position = scroll * factor * 50 * direction;
			sp[i].style.transform = 'translate3d(0px, ' + position + 'px, 0px)';
		}
	}
});

function isInView(el) {
	let r = el.getBoundingClientRect();
	let html = document.documentElement;
	return (
		r.top >= 0 &&
		r.left >= 0 &&
		r.bottom <= (window.innerHeight || html.clientHeight) &&
		r.right <= (window.innerWidth || html.clientWidth)
	);
}
